import GridTile from "../grid/GridTile";
import Color from "../color/Color";
import ColoredShadowCastCallback from "./ColoredShadowCastCallback";

export default class DynamicLightSourceCastCallback extends ColoredShadowCastCallback {
    /**
     * @param {Color} lightColor 
     * @param {number} lightSourceCastRadius 
     */
    constructor(lightColor, lightSourceCastRadius) {
        super(lightColor, lightSourceCastRadius);
    }

    /**
     * @override
     * @param {GridTile} tile 
     * @param {number} radius 
     * @param {number} lightFraction 
     */
    tileLighted(tile, radius, lightFraction) {
        //tile.lighting.addDynamicLighting(this.calculatedLightedColor(radius, lightFraction));
        tile.addDynamicLighting(this.calculatedLightedColor(radius, lightFraction));
    }
}
